export default "__VITE_ASSET__BympuOpt__"